const clearMultiplySpaces = (incomeStr: string): string => incomeStr
    ?.split(' ')
    .map((word) => word.trim())
    .filter(Boolean)
    .join(' ');

export default clearMultiplySpaces;
